import type { SVGProps } from 'react';

type PhoneIconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
  color?: string;
};

export const PhoneIcon = ({
  size = 20,
  color = 'currentColor',
  style,
  ...props
}: PhoneIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M7.825 5.00817C7.975 5.2165 8.08333 5.40817 8.15833 5.5915C8.23333 5.7665 8.275 5.9415 8.275 6.09984C8.275 6.29984 8.21666 6.49984 8.1 6.6915C7.99166 6.88317 7.83333 7.08317 7.63333 7.28317L7 7.9415C6.90833 8.03317 6.86666 8.1415 6.86666 8.27484C6.86666 8.3415 6.875 8.39984 6.89166 8.4665C6.91666 8.53317 6.94166 8.58317 6.95833 8.63317C7.10833 8.90817 7.36666 9.2665 7.73333 9.69984C8.10833 10.1332 8.50833 10.5748 8.94166 11.0165C9.39166 11.4582 9.825 11.8665 10.2667 12.2415C10.7 12.6082 11.0583 12.8582 11.3417 13.0082C11.3833 13.0248 11.4333 13.0498 11.4917 13.0748C11.5583 13.0998 11.625 13.1082 11.7 13.1082C11.8417 13.1082 11.95 13.0582 12.0417 12.9665L12.675 12.3415C12.8833 12.1332 13.0833 11.9748 13.275 11.8748C13.4667 11.7582 13.6583 11.6998 13.8667 11.6998C14.025 11.6998 14.1917 11.7332 14.375 11.8082C14.5583 11.8832 14.75 11.9915 14.9583 12.1332L17.7167 14.0915C17.9333 14.2415 18.0833 14.4165 18.175 14.6248C18.2583 14.8332 18.3083 15.0415 18.3083 15.2748C18.3083 15.5748 18.2417 15.8832 18.1 16.1832C17.9583 16.4832 17.775 16.7665 17.5333 17.0332C17.125 17.4832 16.675 17.8082 16.1667 18.0165C15.6667 18.2248 15.125 18.3332 14.5417 18.3332C13.6917 18.3332 12.7833 18.1332 11.825 17.7248C10.8667 17.3165 9.90833 16.7665 8.95833 16.0748C8 15.3748 7.09166 14.5998 6.225 13.7415C5.36666 12.8748 4.59166 11.9665 3.9 11.0165C3.21666 10.0665 2.66666 9.1165 2.26666 8.17484C1.86666 7.22484 1.66666 6.3165 1.66666 5.44984C1.66666 4.88317 1.76666 4.3415 1.96666 3.8415C2.16666 3.33317 2.48333 2.8665 2.925 2.44984C3.45833 1.92484 4.04166 1.6665 4.65833 1.6665C4.89166 1.6665 5.125 1.7165 5.33333 1.8165C5.55 1.9165 5.74166 2.0665 5.89166 2.28317"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4167 7.50016C15.4167 7.00016 15.025 6.2335 14.4417 5.6085C13.9083 5.0335 13.2 4.5835 12.5 4.5835"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.175 1.90817C13.6417 1.74984 13.0833 1.6665 12.5 1.6665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 7.5001C18.3333 5.5251 17.35 3.7751 15.85 2.7251"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
